import React from "react";
import { History, Sparkles, UserRound } from "lucide-react";

const ROLE_LABELS = { super_admin: "Super admin", manager: "Manager", moderator: "Modérateur", associate: "Associé", support: "Support" };
const ACTIONS = {
  created: "Article créé", created_ai: "Brouillon rédigé par l'IA", updated: "Modifié", translated_ai: "Traduit par l'IA", cover_ai: "Couverture générée par l'IA",
  published: "Validé et publié", scheduled: "Validé et programmé", unpublished: "Dépublié (retour en brouillon)",
};
const COLORS = { published: "#15803D", scheduled: "#1D4ED8", unpublished: "#B45309", created_ai: "#7C3AED", translated_ai: "#7C3AED", cover_ai: "#7C3AED" };
const fmt = (iso) => { try { return new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); } catch { return "—"; } };
const roleOf = (roles = []) => ["super_admin", "manager", "moderator", "associate", "support"].find((r) => roles.includes(r));

export const Actor = ({ by, testId }) => {
  const isAi = !by || !by.id;
  const role = roleOf(by?.roles);
  return (
    <span className="inline-flex items-center gap-1 font-semibold" data-testid={testId}>
      {isAi ? <Sparkles size={12} /> : <UserRound size={12} />}{isAi ? "IA Yalola" : (by.name || "Compte supprimé")}
      {role && <span className="rounded-full px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide" style={{ background: "var(--yalola-surface-alt)", color: "var(--yalola-text-muted)" }}>{ROLE_LABELS[role]}</span>}
    </span>
  );
};

// Historique interne d'un article (jamais exposé au public) : qui a créé / modifié / traduit / validé-publié, et quand.
export const ResourceHistory = ({ history = [] }) => {
  const rows = [...history].reverse();
  return (
    <div className="yalola-card p-4 space-y-2" data-testid="res-history">
      <div className="text-sm font-bold flex items-center gap-2"><History size={16} />Historique</div>
      {rows.length === 0 && <p className="text-xs" style={{ color: "var(--yalola-text-muted)" }}>Aucune action enregistrée.</p>}
      <ul className="space-y-1.5">
        {rows.map((h, i) => (
          <li key={i} className="text-xs flex flex-wrap items-center gap-x-1.5 gap-y-0.5" data-testid={`res-history-${h.action}`}>
            <span className="font-bold" style={{ color: COLORS[h.action] || "var(--yalola-text)" }}>{ACTIONS[h.action] || h.action}</span>
            <span style={{ color: "var(--yalola-text-muted)" }}>par</span><Actor by={h.by} />
            {h.meta?.requested_by && <><span style={{ color: "var(--yalola-text-muted)" }}>à la demande de</span><Actor by={h.meta.requested_by} /></>}
            {h.meta?.langs && <span style={{ color: "var(--yalola-text-muted)" }}>({h.meta.langs.map((l) => l.toUpperCase()).join(", ")})</span>}
            <span style={{ color: "var(--yalola-text-muted)" }}>· {fmt(h.at)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
